import { render, staticRenderFns } from "./ClosedOrders.vue?vue&type=template&id=2138315e&"
import script from "./ClosedOrders.vue?vue&type=script&lang=js&"
export * from "./ClosedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports